module.exports = __webpack_public_path__ + "static/media/sis_bg_1.f4b3bf9d.jpg";